/**
 * 通用工具类
 */

import { Message } from 'element-ui'
import router from '../router'

/**
 * 判断是否为空
 * @param data
 * @returns {boolean}
 */
export function isNull(data) {
    if (data === undefined) {
        return true
    } else if (data === null) {
        return true
    } else if (typeof data === 'string' && (data.length === 0 || data === '' || data === 'undefined' || data === 'null')) {
        return true
    } else if ((data instanceof Array) && data.length === 0) {
        return true
    }
    return false
}

/**
 * 判断不为空
 * @param data
 * @returns {boolean}
 */
export function isNotNull(data) {
    return !isNull(data)
}

/**
 * 显示顶部红色通知
 * @param msg
 */
export function showDanger(msg) {
    if (isNull(msg)) {
        return
    }
    Message({
        message: msg,
        type: 'error',
        showClose: true
    })
}

/**
 * 显示顶部橙色通知
 * @param msg
 */
export function showWarning(msg) {
    if (isNull(msg)) {
        return
    }
    Message({
        message: msg,
        type: 'warning',
        showClose: true
    });
}

/**
 * 显示顶部绿色通知
 * @param msg
 */
export function showSuccess(msg) {
    if (isNull(msg)) {
        return
    }
    Message({
        message: msg,
        type: 'success',
        showClose: true
    })
}

/**
 * 页面跳转
 * @param path
 * @param isRepalce
 */
export function goToPage(path, isRepalce) {
    if (isRepalce) {
        router.replace(path)
    } else {
        router.push(path)
    }
}

/**
 * 生成UUID
 * @returns {string}
 */
export function getUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

/**
 * 验证手机号格式
 * @param {string} mobile 手机号
 * @param {string} areaCode 区号
 * @returns {boolean}
 */
export function validateMobile(mobile, areaCode) {
    // 移除所有非数字字符
    const cleanMobile = mobile.replace(/\D/g, '');

    // 根据不同区号使用不同的验证规则
    switch (areaCode) {
        case '+86': // 中国大陆
            return /^1[3-9]\d{9}$/.test(cleanMobile);
        default:
            // 其他国际号码：至少5位，最多15位
            return /^\d{5,15}$/.test(cleanMobile);
    }
}

/**
 * 获取完整图片URL
 * @param {string} url 
 * @returns {string}
 */
export function getFullUrl(url) {
  if (!url) {
    return '/static/avatars/user-avatar1.png'
  }
  
  if (url.startsWith('default:')) {
    const n = url.split(':')[1]
    return `/static/avatars/user-avatar${n}.png`
  }

  if (url.startsWith('data:') || url.startsWith('blob:')) {
    return url
  }
  
  if (url.startsWith('/static/')) {
    return url
  }

  // OSS签名URL（旧数据兼容）：从签名URL中提取objectKey，通过代理接口访问
  // 签名URL格式: https://bucket.oss-cn-beijing.aliyuncs.com/assets/xxx.jpg?OSSAccessKeyId=...
  if (url.startsWith('http://') || url.startsWith('https://')) {
    try {
      const parsed = new URL(url)
      // 检查是否是OSS域名（包含aliyuncs.com或自定义域名）
      if (parsed.hostname.includes('aliyuncs.com') || parsed.hostname.includes('yyb-asset')) {
        let objectKey = parsed.pathname
        if (objectKey.startsWith('/')) {
          objectKey = objectKey.substring(1)
        }
        if (objectKey) {
          const baseUrl = process.env.VUE_APP_API_BASE_URL || '/api'
          return `${baseUrl}/oss/resource?objectKey=${encodeURIComponent(objectKey)}`
        }
      }
    } catch (e) {
      // URL解析失败，直接返回
    }
    return url
  }

  // OSS objectKey：不以/开头的相对路径，通过后端代理接口访问
  if (!url.startsWith('/')) {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || '/api'
    return `${baseUrl}/oss/resource?objectKey=${encodeURIComponent(url)}`
  }
  
  const baseUrl = process.env.VUE_APP_API_BASE_URL || '/api'
  return `${baseUrl}${url}`
}

export function formatDate(value, fmt) {
  if (!value) return ''
  const date = new Date(value)
  if (isNaN(date.getTime())) return ''
  if (!fmt) fmt = 'yyyy-MM-dd HH:mm:ss'
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

export function formatFileSize(bytes) {
  if (bytes === 0 || bytes === null || bytes === undefined) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(Math.abs(bytes)) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}
